import { P } from '../theme/tokens';

const TAG_TONES = [
  [/emergency|urgent|flood|fire/i, P.danger],
  [/hvac|a\/?c\b|heat|air/i, P.cyan],
  [/maintenance|repair/i, P.warning],
  [/leasing|prospect/i, P.info],
  [/tenant/i, P.success],
  [/owner/i, P.purple]
];

export const tagColor = (tag = '') => TAG_TONES.find(([rx]) => rx.test(tag))?.[1] || P.subtle;

export const ROLE_META = {
  prospect: { label: 'Prospect', color: P.info },
  tenant: { label: 'Tenant', color: P.success },
  owner: { label: 'Owner', color: P.purple },
  vendor: { label: 'Vendor', color: P.cyan },
  contact: { label: 'Contact', color: P.subtle }
};
